// Twemoji sprite cache for canvas stickers (coherent cross-platform emoji rendering).
const cache = new Map<string, HTMLImageElement | null>();
let onReady: (() => void) | null = null;

export const setEmojiReadyHandler = (cb: () => void) => { onReady = cb; };

export function codepoints(emoji: string): string {
  return Array.from(emoji).filter((ch) => ch !== "\uFE0F").map((ch) => ch.codePointAt(0)!.toString(16)).join("-");
}

export function emojiImage(emoji: string): HTMLImageElement | null {
  const key = codepoints(emoji);
  if (cache.has(key)) return cache.get(key) ?? null;
  cache.set(key, null);
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.onload = () => { cache.set(key, img); onReady?.(); };
  img.onerror = () => cache.set(key, null);
  img.src = `https://cdn.jsdelivr.net/gh/jdecked/twemoji@15.1.0/assets/72x72/${key}.png`;
  return null;
}

export const EMOJI_SET = ["🔥", "🚀", "💎", "🎯", "⚡", "✅", "❌", "⚠️", "👀", "💰", "📈", "📉", "🐂", "🐻", "🧲", "🔒", "⭐", "💡", "🕒", "🏁", "🧠", "🩸", "🪙", "🎲"];
